export default '2.0.118-release-core-1.65';
